<template>

  <div v-if="pages > 1">
    <ul v-if="pages <= 6" class="pagination">

      <li class="page-item" v-bind:class="{'disabled': page == 1}">
        <router-link :to="{ query: page > 2 ? Object.assign({}, $route.query, { page: page - 1 }) : Object.assign({}, $route.query, { page: undefined }) }" class="page-link rounded">
          <i class="fas fa-arrow-left small"></i>
        </router-link>
      </li>

      <li v-for="p in pages" class="page-item" v-bind:class="{'active': page == p}">
        <router-link :to="{ query: p > 1 ? Object.assign({}, $route.query, { page: p }) : Object.assign({}, $route.query, { page: undefined }) }" class="page-link">{{ p }}</router-link>
      </li>

      <li v-bind:class="{'disabled': pages <= page}" class="page-item">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: page + 1 }) }" class="page-link rounded">
          <i class="fas fa-arrow-right small"></i>
        </router-link>
      </li>

    </ul>

    <ul v-else class="pagination">

      <li class="page-item" v-bind:class="{'disabled': page == 1}">
        <router-link v-bind:to="{ query: page > 2 ? Object.assign({}, $route.query, { page: page - 1 }) : Object.assign({}, $route.query, { page: undefined }) }" class="page-link rounded">
          <i class="fas fa-arrow-left small"></i>
        </router-link>
      </li>

      <li class="page-item" v-bind:class="{'active': page == 1}">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: undefined }) }" class="page-link">1</router-link>
      </li>

      <li v-if="pages > 1" class="page-item" v-bind:class="{'active': page == 2}">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: 2 }) }" class="page-link">2</router-link>
      </li>

      <li v-if="page == 1 && pages > 2" class="page-item" v-bind:class="{'active': page == 3}">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: 3 }) }" class="page-link">3</router-link>
      </li>

      <li v-if="page == 5">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: 3 }) }" class="page-link">3</router-link>
      </li>
      <li v-else-if="page > 5" class="page-item disabled">
        <a class="page-link">...</a>
      </li>

      <li v-if="page > 3" class="page-item">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: this.page - 1 }) }" class="page-link">{{page - 1}}</router-link>
      </li>

      <li v-if="page >= 3" class="page-item active">
        <router-link :to="{ query: $route.query}" class="page-link">{{ page }}</router-link>
      </li>

      <li v-if="page < pages && page > 1" class="page-item">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: this.page + 1 }) }" class="page-link">{{ page + 1}}</router-link>
      </li>

      <li v-if="page + 1 < pages && page > 1" class="page-item">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: this.page + 2 }) }" class="page-link">{{ page + 2}}</router-link>
      </li>

      <li v-if="page + 3 == pages">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: this.page + 3 }) }" class="page-link">{{ page + 3}}</router-link>
      </li>
      <li v-else-if="page + 3 < pages" class="page-item disabled">
        <a class="page-link">...</a>
      </li>

      <li v-bind:class="{'disabled': pages <= page}" class="page-item">
        <router-link :to="{ query: Object.assign({}, $route.query, { page: this.page + 1 }) }" class="page-link rounded">
          <i class="fas fa-arrow-right small"></i>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: [
    'pages'
  ],
  data: () =>({
    page: 1
  }),
  created(){
    this.page = parseInt(this.$route.query.page) || 1;
  },
}
</script>
